var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarIcon = function SvgStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.038 1.817c.186-.572.996-.572 1.181 0l.983 3.025a.62.62 0 0 0 .59.43h3.182c.601 0 .851.769.365 1.123l-2.574 1.87a.62.62 0 0 0-.225.693l.983 3.026c.186.572-.47 1.047-.956.694l-2.573-1.87a.62.62 0 0 0-.73 0l-2.573 1.87c-.487.353-1.142-.122-.956-.694l.983-3.026a.62.62 0 0 0-.225-.694l-2.574-1.87c-.486-.353-.236-1.123.365-1.123h3.181a.62.62 0 0 0 .59-.429z"
  })));
};
export default SvgStarIcon;